module.exports = "label{width:100%}\n"